import type { ConversationMetadata } from 'types/ai.types';
import type { DocumentItem } from 'types/repository.types';
import { useSetAiMetadata } from '.';

export const mapRepositoryDocumentMetadata = (
  repositoryDocument: Partial<DocumentItem>,
): ConversationMetadata => ({
  documentId: repositoryDocument?._id,
  documentType: 'repository_document',
  data: {
    AISummary: repositoryDocument?.AISummary,
    filename: repositoryDocument?.file?.path?.split('/').pop(),
    tags: repositoryDocument?.tags?.map((tag) => tag.name),
  },
});

export const useRepositoryDocumentAiMetadata = (
  repositoryDocument?: Partial<DocumentItem>,
): void =>
  useSetAiMetadata(
    repositoryDocument,
    'repository_document',
    mapRepositoryDocumentMetadata,
  );
